<template>
    <div>
        <div class="menu-footer">
            <ul class="menu-footer-ul">
                <li>
                  <router-link v-if="!requestServiceUrl" :to="{name: 'request-service'}" class="menu-footer__rs"><i class="far fa-clipboard"></i><span>Request Service</span></router-link>
                  <a v-if="requestServiceUrl" :href="requestServiceUrl" class="menu-footer__rs" target="_blank"><i class="far fa-clipboard"></i><span>Request Service</span></a>
                </li>
                <li><router-link :to="{name: 'events'}"><i class="far fa-calendar-alt"></i><span>Appointments</span></router-link></li>
                <li><router-link :to="{name: 'invoices'}"><i class="far fa-file-alt"></i><span>Invoices</span></router-link></li>
                <li><a href="#" @click.prevent="showDrawer = !showDrawer"><i class="fas fa-ellipsis-h"></i><span>More</span></a></li>
            </ul>
        </div>
        <div class="bottom-drawer" data-menu-footer="drawer" v-if="showDrawer">
            <div class="bottom-drawer__backdrop" @click.prevent="showDrawer = false"></div>
            <div class="bottom-drawer__dialog">
                <ul class="bottom-drawer__menu">
                    <li><router-link :to="{name: 'estimates'}">Estimates<i class="far fa-file"></i></router-link></li>
                    <li><router-link :to="{name: 'deals'}">Deals<i class="far fa-money-bill-alt"></i></router-link></li>
                    <li><router-link :to="{name: 'files'}">File Vault<i class="far fa-folder"></i></router-link></li>
                    <li><router-link :to="{name: 'contact'}">Contact Us<i class="far fa-comment-dots"></i></router-link></li>
                    <li><a @click.prevent="share()" v-if="canShare()">Share<i class="fas fa-share-alt"></i></a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import store from '@/store';

export default {
  name: 'navbar-bottom',
  props: {
    requestServiceUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showDrawer: false,
    };
  },
  methods: {
    canShare() {
      return window.navigator.share;
    },
    share() {
      const shareData = [
        store.getters.business.name,
        `${store.getters.business.first_name} ${store.getters.business.last_name}`,
        this.$options.filters.formatPhone(store.getters.business.phone),
        store.getters.business.email,
      ];

      if (window.navigator.share) {
        window.navigator.share({
          title: store.getters.business.name,
          text: shareData.filter((val) => { return val; }).join(', '),
          url: store.getters.business.website ? store.getters.business.website : store.getters.businessUrlProfile,
        }).then(() => {
          console.log('Thanks for sharing!');
        }).catch(console.error);
      }
    },
  },
};
</script>

<style scoped>

.menu-footer {
  min-height: 56px;
  position: fixed;
  z-index: 2000;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #e1e1e1;
  padding-left: 4px;
  padding-right: 4px;
}
.menu-footer-ul {
  list-style: none;
  padding: 0 10px;
  margin: 0;
  font-size: 9px;
  letter-spacing: 0;
  text-align: center;
  width: 100%;
  height: 56px;
  line-height: 1.2em;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.menu-footer-ul li {
  display: block;
  font-size: 18px;
  width: 100%;
}
.menu-footer-ul li a {
  color: #90a0ac;
  display: inline-block;
}
.menu-footer-ul li a span {
  display: block;
  font-size: 12px;
  margin-top: 6px;
}

.menu-footer__rs {
  white-space: nowrap;
  padding-right: 12px;
}

.bottom-drawer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
}
.bottom-drawer__backdrop {
  height: 100vh;
  background-color: #000;
  opacity: 0.5;
}
.bottom-drawer__dialog {
  position: fixed;
  z-index: 3000;
  bottom: 56px;
  right: 0;
  background: #fff;
  width: 100%;
  text-align: right;
  padding: 20px 44px 20px 20px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.bottom-drawer__menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
.bottom-drawer__menu li a {
  display: inline-block;
  padding: 10px 0;
  color: #90a0ac;
  font-weight: 500;
}
.bottom-drawer__menu li a i {
  width: 26px;
  margin-left: 20px;
  text-align: center;
}

</style>
